import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ArrowUpRight, Target, FileCheck2, CheckCircle2 } from "lucide-react";

export default function ExamPrep() {
  const [courses, setCourses] = useState([]);
  useEffect(() => { api.get("/courses", { params: { category: "exam_prep" } }).then((r) => setCourses(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <section className="grain bg-ink text-rice">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
          <span className="label text-gold">Competitive & University Exams</span>
          <h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tighter mt-5 text-rice max-w-3xl">
            Prepare to <span className="italic text-gold">succeed</span> — UGC NET & PG entrance.
          </h1>
          <p className="text-rice/60 mt-6 max-w-2xl text-lg">
            Specialised coaching for the two exams that matter most to India's Chinese learners: the
            UGC NET Chinese (for lectureship & JRF) and the CUET PG Chinese entrance examination.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid md:grid-cols-2 gap-8">
        {courses.map((c) => (
          <div key={c.course_id} className="border border-black/10 bg-white p-8 flex flex-col" data-testid={`examprep-${c.slug}`}>
            <div className="flex items-center gap-3 text-cinnabar mb-4">
              {c.slug === "ugc-net-chinese" ? <FileCheck2 size={22} /> : <Target size={22} />}
              <span className="label text-gold">{c.hsk}</span>
            </div>
            <h3 className="font-serif text-3xl">{c.title}</h3>
            <p className="text-clay mt-4 leading-relaxed flex-1">{c.description}</p>
            <ul className="mt-6 space-y-2 text-sm text-clay">
              {c.syllabus.slice(0, 4).map((s, i) => (
                <li key={i} className="flex items-start gap-2"><CheckCircle2 size={15} className="text-cinnabar mt-0.5 shrink-0" /> {s}</li>
              ))}
            </ul>
            <div className="mt-8 flex items-center justify-between">
              <div>
                <p className="font-display font-extrabold text-2xl text-ink">₹{c.price_inr.toLocaleString("en-IN")}</p>
                <p className="text-xs text-clay">{c.duration}</p>
              </div>
              <Link to={`/courses/${c.slug}`} data-testid={`examprep-details-${c.slug}`}
                className="inline-flex items-center gap-2 px-6 py-3 bg-ink text-rice text-sm hover:bg-cinnabar transition-colors duration-300">
                Details <ArrowUpRight size={16} />
              </Link>
            </div>
          </div>
        ))}
      </section>

      <section className="bg-white border-y border-black/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-3 gap-8">
          {[
            { t: "Full syllabus coverage", d: "Every unit mapped to the latest exam pattern." },
            { t: "Mock tests & analysis", d: "Timed papers with detailed evaluation and feedback." },
            { t: "Expert mentoring", d: "Guidance from experienced Chinese language faculty." },
          ].map((x, i) => (
            <div key={i} className="border-l-2 border-cinnabar pl-5">
              <h3 className="text-xl">{x.t}</h3>
              <p className="text-sm text-clay mt-2 leading-relaxed">{x.d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
